import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";

export const getEncabezadosIngresosCombustiblesFechas = async(dates) =>{
    const result = await PrivateInterceptor(`Inventario/Combustibles/IngresosCombustible/FechasEncabezado`, 'POST', {Fecha1 :dates[0], Fecha2: dates[1]})
    return result
}